var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssessmentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "81px",
    height: "84px",
    viewBox: "0 0 81 84",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "assessment-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "course-detail",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "learners",
    transform: "translate(-674.000000, -2076.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "assessment-icon",
    transform: "translate(670.619048, 2074.619048)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0929039,16.0748185 C17.080793,16.0745986 17.0686792,16.0745988 17.0565684,16.074819 C16.5043749,16.0848591 16.0648727,16.5406395 16.0749129,17.092833 L17.0250603,69.3496128 C17.0348434,69.8876707 17.4686806,70.3214979 18.0067388,70.3312686 L70.340039,71.2816005 C70.3521499,71.2818205 70.3642637,71.2818203 70.3763745,71.2816001 C70.928568,71.27156 71.3680701,70.8157796 71.35803,70.2635861 L70.4078826,18.0068063 C70.3980995,17.4687484 69.9642623,17.0349211 69.4262041,17.0251504 L17.0929039,16.0748185 Z",
    id: "Rectangle",
    stroke: "#000000",
    strokeWidth: 6,
    fill: "#FFFFFF",
    transform: "translate(43.716471, 43.678210) rotate(46.000000) translate(-43.716471, -43.678210) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0745509,21.9901614 C41.5248119,21.9901614 28.8657491,30.863046 28.7900174,33.4553325 C28.7142857,36.047619 32.0379234,36.8897978 34.9635711,37.8650137 C36.2777324,38.3030675 37.4408811,39.8312817 41.2857143,39.1904762 C47.5714286,38.1428571 55.789573,33.8295719 56.1300409,33.4553325 C59.2202897,30.0585576 54.1771666,21.9901614 49.0745509,21.9901614 Z",
    id: "Oval",
    fill: "#7BC440",
    opacity: 0.894042969
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(26.631229, 22.532743)",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1838317,31.77512 L17.3632337,41.6422296",
    id: "Line-4",
    transform: "translate(17.273533, 36.708675) rotate(-495.000000) translate(-17.273533, -36.708675) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2692258,31.8601226 L17.2692258,41.5478302",
    id: "Line-4",
    transform: "translate(17.269226, 36.703976) rotate(-405.000000) translate(-17.269226, -36.703976) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2639254,-0.43266617 L19.2639254,10.0207292",
    id: "Line-4",
    transform: "translate(19.263925, 4.794032) rotate(-315.000000) translate(-19.263925, -4.794032) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4615566,5.68239163 L14.4615566,8.97035963",
    id: "Line-4",
    transform: "translate(14.461557, 7.326376) rotate(-585.000000) translate(-14.461557, -7.326376) "
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessmentIcon);
export default __webpack_public_path__ + "static/media/assessment-icon.ef6386f03a273b130746ebd9c5762738.svg";
export { ForwardRef as ReactComponent };